declare global {
  /**
   * This namespace provides APIs to interact with otto components programmatically
   * Each Component may or may not provide functionality to interact with it.
   */
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface OttoComponents {}

  interface Window {
    /**
     * This namespace provides APIs to interact with otto components programmatically
     * Each Component may or may not provide functionality to interact with it.
     */
    o_components: OttoComponents;
  }
}

window.o_components ||= {} as OttoComponents;

// eslint-disable-next-line camelcase
export const { o_components: components } = window;
